import styled from 'styled-components';
import { theme } from '../../theme';

export const DivStep = styled.div`
  visibility: hidden;
  height: 0;
  overflow: hidden;

  &.active {
    height: auto;
    visibility: visible;
  }
`;

export const DivColumn = styled.div`
  width: 100%;

  ${theme.up(theme.breakpoints.lg)} {
    width: 44%;

    &.full-width {
      width: 100%;
    }
  }
`;

export const DivTitle = styled.div`
  margin-bottom: 1.231rem;
  font-size: 1.154rem;
  font-weight: 600;
  color: ${theme.colors.primary};
`;

export const DivInnerFields = styled.div`
  margin-left: 1.846rem;
  height: auto;

  &.hidden {
    visibility: hidden;
    height: 0;
  }

  & > div:not(:last-child) {
    margin-bottom: 1.231rem;
  }
`;

export const DivFormWrapper = styled.div`
  min-height: 23.077rem;
  position: relative;
`;

export const SpanTitleCount = styled.span`
  display: flex;
  margin-left: 1.154rem;
  font-weight: 600;
  font-size: 1.231rem;
  line-height: 1.538rem;
  color: ${theme.colors.textDeaccent};
`;

export const DivRow = styled.div`
  margin-bottom: 1.923rem;
`;
